/* eslint-disable */

const CURRENT_GAME = 'current_game'

export default class LocalStorage {

    saveGame(game) {
        const saveGame = {name: game.name, players: game.players, kartengeber: game.kartengeber}
        const savedGames = this.loadSavedGames();
        let index = savedGames.indexOf(saveGame)

        if(index === -1) {
            index = 0
        }

        savedGames[index] = saveGame
        localStorage.setItem('saved_games', JSON.stringify(savedGames))
    }

    savePlayers(players) {
        localStorage.setItem('players', JSON.stringify(players))
    }

    saveKartenGeber(kartengeber) {
        localStorage.setItem('kartengeber', kartengeber)
    }

    saveGameStarted(gameStarted) {
        localStorage.setItem('game_started', gameStarted)
    }

    saveAutoSave(enabled, gamename) {
        localStorage.setItem('autosave_settings', JSON.stringify({enabled, name: gamename}))
    }

    getAutoSave() {
        return JSON.parse(localStorage.getItem('autosave_settings'))
    }

    getCurrentGame() {
        const players =  JSON.parse(localStorage.getItem('players'))
        const kartenGeber = localStorage.getItem('kartengeber');
        const gameStarted = (localStorage.getItem('game_started') === "true"? true : false)

        return {players, kartenGeber, gameStarted}
    }

    loadSavedGames() {
        const savedGames =  JSON.parse(localStorage.getItem('saved_games'))

        if(!savedGames) {
            return []
        }

        return savedGames
    }
}